// External libraries
import React from 'react';
import { LoadingElement } from '@/components/Common';
import { css } from '@emotion/core';

// Internal modules
import { getLazyLoaderRenderFunction, lazyLoader, logger } from '@/lib';
import { CardIconsBarLoadingElement } from './CardFields/CardIconsBar/Components';

// Register lazy loaded inputs so that we can track when they load and
// fire off an FPTI log for the page load event once everything is loaded
logger.fptiTrackPageLoad.registerItem('CardFields');

/**
 * First LoadingElement for CardIconsBar
 * Second LoadingElement for CardNumber
 * Last LoadingElement for CardExpiry & CardCvv which are on same line
 */
const styles = css({ marginBottom: '12px' });
const CardLoadingFields = () => (
  <>
    <CardIconsBarLoadingElement />
    <LoadingElement styleOverrides={styles} />
    <LoadingElement />
  </>
);

export const LazySplitCardFields = lazyLoader({
  loader: () => import('./CardFields/SplitCardFields'),
  loading: CardLoadingFields,
  name: 'card_fields',
  render: getLazyLoaderRenderFunction({
    componentName: 'SplitCardFields',
    fptiTrackName: 'CardFields',
  }),
});

/**
 * First LoadingElement for Tabs
 * Second LoadingElement for Iban
 * Last LoadingElement for DOB
 */
const BankLoadingFields = () => (
  <>
    <LoadingElement height="44px" styleOverrides={styles} viewBoxHeight="44" />
    <LoadingElement styleOverrides={styles} />
    <LoadingElement />
  </>
);

export const LazyBankFields = lazyLoader({
  loader: () => import('./BankFields'),
  loading: BankLoadingFields,
  name: 'bank_fields',
  render: getLazyLoaderRenderFunction({
    componentName: 'BankFields',
  }),
});
